import { ListTabState } from "./list-tab-state";
import { prop } from "../../../decorators/property";

export class CitelineListTabState extends ListTabState {
    @prop() public CiteLineEngaged = false;
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/tabs/citeline-list-tab-state.ts